import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import Input from "@/components/atoms/Input";

interface PasswordInputProps {
  field: {
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: () => void;
  };
  placeholder?: string;
}

const PasswordInput = ({ field, placeholder }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      {/* Parola Girdisi */}
      <Input
        {...field}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder || "Password"}
        className="pr-10" // Sağ tarafta göz simgesi için alan bırakın.
      />
      {/* Göz Simgesi */}
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
      >
        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

export default PasswordInput;